import Api from '@/api/api.js'

export default {
    async getProducts() {
        return Api().get('/auth/products');
    },
    async getProduct(id) {
        return Api().get('/auth/products/'+id);
    },
    async newProduct() {
        return Api().post('/auth/products/new');
    },
    async saveProduct(id, product) {
        return Api().post('/auth/products/'+id, product);
    },
    async deleteProduct(id) {
        return Api().delete('/auth/products/'+id);
    },
    async duplicateProduct(id) {
        return Api().post('/auth/products/'+id+'/duplicate');
    },
}